import React from 'react';

const ICONS = {
  home: (
    <path
      fill="currentColor"
      d="M10 2L2 9v11h6v-6h4v6h6V9L10 2zm0 2.8L16 10v8h-2v-6H6v6H4v-8l6-5.2z"
    />
  ),
  document: (
    <path
      fill="currentColor"
      d="M6 2h8l4 4v14a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm8 1.5V7h3.5L14 3.5zM7 9h10v2H7V9zm0 4h10v2H7v-2zm0 4h7v2H7v-2z"
    />
  ),
  currency: (
    <path
      fill="currentColor"
      d="M12 2a8 8 0 100 16 8 8 0 000-16zm.5 3v1.1A3.5 3.5 0 0115.9 9H14a2 2 0 00-2-2V5h.5zm-1 0H11v2a2 2 0 00-2 2H7.1A3.5 3.5 0 0111.5 6.1V5zm-4.4 4.9H9a3.5 3.5 0 003.5 3.5V15H11a2 2 0 00-2 2v.9A3.5 3.5 0 017.1 9.9zm6.8 0A3.5 3.5 0 0116.9 15H15a2 2 0 00-2-2v-1.1h1.4zm-1.3 5.1V15h1.4a3.5 3.5 0 01-3.4 2.6V17a2 2 0 002-2z"
    />
  ),
  target: (
    <path
      fill="currentColor"
      d="M12 4a8 8 0 108 8 8 8 0 00-8-8zm0 2a6 6 0 110 12 6 6 0 010-12zm0 3a3 3 0 100 6 3 3 0 000-6zm0 1.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
    />
  ),
  search: (
    <path
      fill="currentColor"
      d="M9 3a6 6 0 014.9 10.3l4.4 4.4-1.4 1.4-4.4-4.4A6 6 0 119 3zm0 2a4 4 0 100 8 4 4 0 000-8z"
    />
  ),
  chart: (
    <path
      fill="currentColor"
      d="M4 18h16v2H2V4h2v14zm3-2h2V9H7v7zm4 0h2V6h-2v10zm4 0h2v-5h-2v5z"
    />
  ),
  edit: (
    <path
      fill="currentColor"
      d="M3 17.5V21h3.5L17.8 9.7l-3.5-3.5L3 17.5zm14.7-9.8a1 1 0 000-1.4l-1.5-1.5a1 1 0 00-1.4 0l-1.2 1.2 3.5 3.5 1.2-1.2z"
    />
  ),
  casino: (
    <path
      fill="currentColor"
      d="M4 4h16v4H4V4zm2 2v2h2V6H6zm10 0v2h2V6h-2zM4 10h16v10H4V10zm2 2v6h12v-6H6zm2 2h2v2H8v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2z"
    />
  ),
  gamepad: (
    <path
      fill="currentColor"
      d="M8 10H6v2H4v2h2v2h2v-2h2v-2h-2v-2zm9.5 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5zM17 8a1 1 0 110 2 1 1 0 010-2zm-2 2a1 1 0 110 2 1 1 0 010-2z"
    />
  ),
  spin: (
    <path
      fill="currentColor"
      d="M12 4a8 8 0 017.4 4.3l-1.8.8A6 6 0 1018 12h2a8 8 0 11-8-8v2l3.5-3.5L12 2v2z"
    />
  ),
  tag: (
    <path
      fill="currentColor"
      d="M21 12l-8.5 8.5a2 2 0 01-2.8 0L2 12.8V5h7.8L21 12zm-3.5-.5L9 3H4v5.5l8.5 8.5 5-5zM7.5 7A1.5 1.5 0 119 5.5 1.5 1.5 0 017.5 7z"
    />
  ),
  card: (
    <path
      fill="currentColor"
      d="M4 6h16a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2zm0 4v8h16v-8H4zm3 2h6v2H7v-2z"
    />
  ),
  grid: (
    <path
      fill="currentColor"
      d="M4 4h7v7H4V4zm9 0h7v7h-7V4zM4 13h7v7H4v-7zm9 0h7v7h-7v-7z"
    />
  ),
  puzzle: (
    <path
      fill="currentColor"
      d="M8 4h3a2 2 0 012 2v1h1a2 2 0 012 2v3h1a2 2 0 010 4h-1v1a2 2 0 01-2 2h-3v-3H9v3H6a2 2 0 01-2-2v-1H3a2 2 0 010-4h1V9a2 2 0 012-2h1V6a2 2 0 012-2h1V4z"
    />
  ),
  users: (
    <path
      fill="currentColor"
      d="M12 12a4 4 0 100-8 4 4 0 000 8zm-8 8v-1a5 5 0 015-5h6a5 5 0 015 5v1H4zm14-6a3 3 0 100-6 3 3 0 000 6zm2 6v-.8a6 6 0 00-3.5-5.5A5 5 0 0120 18v2h2z"
    />
  ),
  alert: (
    <path
      fill="currentColor"
      d="M12 2L1 21h22L12 2zm0 5l7.5 13h-15L12 7zm-1 4v4h2v-4h-2zm0 6v2h2v-2h-2z"
    />
  ),
  shield: (
    <path
      fill="currentColor"
      d="M12 2l8 3v6c0 5.5-3.8 9.7-8 11-4.2-1.3-8-5.5-8-11V5l8-3zm0 2.2L6 6.3v4.7c0 4.2 2.9 7.6 6 8.8 3.1-1.2 6-4.6 6-8.8V6.3l-6-2.1z"
    />
  ),
  trophy: (
    <path
      fill="currentColor"
      d="M6 3h12v3a4 4 0 01-3 3.87V11h4v2h-3v2h2v2H8v-2h2v-2H7v-2h4V9.87A4 4 0 018 6V3zm2 2v1a2 2 0 004 0V5H8zm-4 0H4a2 2 0 002 2h.1A5 5 0 014 5zm14 0h-2a5 5 0 00-2.1 2H16a2 2 0 002-2z"
    />
  ),
  settings: (
    <path
      fill="currentColor"
      d="M12 8a4 4 0 110 8 4 4 0 010-8zm8.5 4a7.5 7.5 0 01-.2 1.7l2 1.5-2 3.5-2.4-1a7.6 7.6 0 01-1.5 1l-.4 2.6H9l-.4-2.6a7.6 7.6 0 01-1.5-1l-2.4 1-2-3.5 2-1.5a7.5 7.5 0 010-3.4l-2-1.5 2-3.5 2.4 1a7.6 7.6 0 011.5-1L9 2.7h6l.4 2.6a7.6 7.6 0 011.5 1l2.4-1 2 3.5-2 1.5c.1.55.2 1.1.2 1.7z"
    />
  ),
  telegram: (
    <path
      fill="currentColor"
      d="M9.5 13.8l-.3 4.2c.4 0 .6-.2.8-.4l2-1.9 4.1 3c.8.4 1.3.2 1.5-.7l2.7-12.7c.3-1.2-.4-1.7-1.2-1.4L2.6 9.3c-1.2.5-1.2 1.1-.2 1.4l4.5 1.4L18.5 6c.7-.4 1.3-.2.8.2l-9.8 7.6z"
    />
  ),
  sparkles: (
    <path
      fill="currentColor"
      d="M12 2l1.2 4.2L17 7.4l-3.8 1.2L12 13l-1.2-4.4L7 7.4l3.8-1.2L12 2zm-7 9l.8 2.8L9 14l-2.8.8L5 18l-.8-2.8L1 14l2.8-.8L5 11zm14 0l.8 2.8L23 14l-2.8.8L19 18l-.8-2.8L15 14l2.8-.8L19 11zM12 16l.6 2.1 2.1.6-2.1.6L12 22l-.6-2.1-2.1-.6 2.1-.6L12 16z"
    />
  ),
  upload: (
    <path
      fill="currentColor"
      d="M11 4h2v7.6l2.3-2.3 1.4 1.4L12 16l-4.7-4.7 1.4-1.4L11 11.6V4zm-7 14h16v2H4v-2z"
    />
  ),
  refresh: (
    <path
      fill="currentColor"
      d="M12 4V1L8 5l4 4V6a6 6 0 016 6h2a8 8 0 10-8-8z"
    />
  ),
  party: (
    <path
      fill="currentColor"
      d="M4 3l1.5 4.5L3 9l4.5 1.5L9 15l1.5-4.5L15 9l-4.5-1.5L9 3 7.5 7.5 3 9l4.5 1.5L9 15zm11 2l.7 2.1L18 7.8l-2.1.7L15 10.6l-.7-2.1L12.2 7.8l2.1-.7L15 5zm2 8l.5 1.5L21 16l-1.5.5L19 18l-.5-1.5L17 16l1.5-.5L19 14z"
    />
  ),
};

export function NavIcon({ name }) {
  const path = ICONS[name] || ICONS.grid;
  return (
    <svg className="nav-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      {path}
    </svg>
  );
}
